import styled, { css } from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Input from "../../../../../../../common-deprecated/styles/v2/toyota/components/Input";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as InteriorSpinView from "../../step-customize/car-hero/styles/InteriorGalleryStyle";

export const FilterWrapper = styled(Flex.Col)`
    margin-bottom: ${theme.space[5]}px;

    @media ${getBreakpoint("up", "lg")} {
        margin-bottom: ${theme.space[2]}px;
    }

    ${Button.Link} {
        margin-top: 0;
        margin-bottom: 0;
        font-size: 1.6rem;
    }
`;

export const CheckBoxList = styled.div`
    ${Input.Radio} {
        margin-bottom: ${theme.space[3]}px;
    }
`;

export const ExteriorGalleryWrapper = styled.div`
    ${InteriorSpinView.SpinInterior} {
        margin-bottom: ${theme.space[2]}px;
        padding-top: 55%;

        @media ${getBreakpoint("up", "md")} {
            padding-top: 40%;
        }

        @media ${getBreakpoint("up", "lg")} {
            padding-top: 27%;
        }
    }

    ${InteriorSpinView.SpinGallery} {
        position: absolute;
    }

    ${InteriorSpinView.SpinImage} {
        position: absolute;
        left: 50%;
        max-width: 553px;
        transform: translateX(-50%);
    }

    ${InteriorSpinView.SpinNav} {
        bottom: 3px;
    }
`;

export const GalleryNavItem = styled(InteriorSpinView.SpinNavItem)`
    ${({ isActive }) => css`
        background-color: ${isActive ? theme.colors.grey2 : theme.colors.primaryBlack};
    `};
`;
